package com.mshopsas.enterprise.aiw.scan.data.scanner

data class ScannerData(
    val data: String,
    val type: ScannerType
)